import profile from '@/apis/coreIAM/profile'
import { profileTypes } from '@/store/mutationTypes'

export default {
    namespaced: true,
    state: {
        profile: null,
        fetchProfile: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [profileTypes.FETCH_PROFILE_REQUEST]: function (state) {
            state.fetchProfile.pending = true;
        },
        [profileTypes.FETCH_PROFILE_SUCCESS]: function (state, profile) {
            state.profile = profile;
            state.fetchProfile.error = null;
            state.fetchProfile.pending = false;
        },
        [profileTypes.FETCH_PROFILE_FAILURE]: function (state, error) {
            state.profile = null;
            state.fetchProfile.error = error;
            state.fetchProfile.pending = false;
        }
    },
    actions: {
        async fetchProfile({ commit }) {
            commit(profileTypes.FETCH_PROFILE_REQUEST)
            return new Promise((resolve, reject) => {
                profile.fetchProfile()
                    .then((profile) => {
                        commit(profileTypes.FETCH_PROFILE_SUCCESS, profile.data)
                        resolve(profile.data)
                    })
                    .catch((error) => {
                        commit(profileTypes.FETCH_PROFILE_FAILURE, error)
                        reject(error)
                    })
            })
        }
    }
}